<template>
  <form v-on:submit.prevent="onSubmit">
    <v-input v-model="url" label="Source" type="hidden"/>
    <v-input v-model="name" label="Name"/>
    <v-input v-model="email" label="Email"/>
    <v-input v-model="phone" label="Phone"/>
    <v-input v-model="message" tag="textarea" label="Message"/>
    <button class="green">SEND REQUEST</button>
    <div v-show="success" class="success">
      <h2>Thank you!</h2>
      <p>Your message has been sent. We will contact you soon.</p>
      <a @click="$store.commit('hideModal'),success = false" class="button green" v-if="modal">
        Close
      </a>
    </div>
  </form>
</template>

<script>
import VInput from './input';
import axios from "axios";

export default {
  components: { VInput },
  props: {
    modal: { type: Boolean, default: false },
  },
  data() {
    return {
      url: '',
      email: '',
      phone: '',
      name:'',
      message: '',
      success: false,
  }
  },
  methods: {
    onSubmit() {
      axios.post('https://api.my2ndpassport.com/addform', {
          firstname:this.name,
          email:this.email,
          phone:this.phone,
          subject:this.message,
          url: this.$route.fullPath,
      }).then(response => {
        //this.response = JSON.stringify(response, null, 2);

        if (response.data == true)
          this.success = true;
        //this.modal=true;
      })
    }
  },
  //mounted() {
  //  axios.get("https://jsonplaceholder.typicode.com/todos/")
  //          .then(response => console.log(response))
  //}
};
</script>

<style lang="scss" scoped>
@import '@/assets/mixins.scss';

form {
  position: relative;
  display: flex;
  flex-direction: column;

  @include mobile {
    justify-content: center;
  }

  @include desktop {
    align-items: center;
    justify-content: space-between;
    max-width: 330px;
  }

  & > *:not(:first-child) {
    margin-top: 20px;
  }

  button {
    margin-top: 30px !important;

    @include mobile {
      align-self: center;
    }
  }
}

h2 {
  font-size: 48px;
  line-height: 60px;
  color: #83ca54;
  font-weight: 400;
  align-self: flex-start;
}

.success {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: #f9f9f9;
  text-align: center;
  margin:0px !important;
}
</style>